import GenericExportButton from "components/GenericExportButton";
import { saveObjectToCsv } from "helpers/excelHelper";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import {
  CompletionsFilter,
  ListRequestOfCompletionsFilter,
  ResponseCode,
} from "services/organizationPortalClient";
import contextStore from "stores/contextStore";

type ExportCompletionsProps = {
  sortField: string;
  sortDescending: boolean;
  filter: CompletionsFilter;
};

const MAX_COMPLETIONS_TO_EXPORT = 10000;

const ExportCompletions = ({
  sortField,
  sortDescending,
  filter,
}: ExportCompletionsProps) => {
  const { formatMessage: t } = useIntl();
  const { organization } = contextStore.useState();
  const { certificatesService } = useGlobalContext();

  const exportCompletions = async (): Promise<void> => {
    const completionsResponse = await certificatesService.getCompletions(
      ListRequestOfCompletionsFilter.fromJS({
        pageSize: MAX_COMPLETIONS_TO_EXPORT,
        sortField: sortField,
        sortDescending: sortDescending,
        parameters: filter,
      })
    );

    const completionsToExport =
      completionsResponse?.data?.map((record) => ({
        "Completion Date": record.completionDate,
        Name: record.firstName,
        "Last Name": record.lastName,
        Email: record.email,
        "Course Availability": record.skuAvailability?.name,
        "Course Title": record.courseTitle,
        Format: record.skuFormat?.plainTextName,
      })) ?? [];

    if (
      completionsResponse.responseCode === ResponseCode.OK &&
      completionsToExport.length
    ) {
      saveObjectToCsv(organization!.name + " completions", completionsToExport);
    } else if (
      completionsResponse.responseCode === ResponseCode.OK &&
      !completionsToExport.length
    ) {
      return Promise.reject(new Error(t({ id: "noCompletionsFound" })));
    } else {
      return Promise.reject(new Error(t({ id: "unexpectedExportError" })));
    }
  };

  return (
    <GenericExportButton
      exportData={exportCompletions}
      exportButtonLabel={t({ id: "completions" })}
      tooltipLabel={t({ id: "exportCompletions" })}
    />
  );
};

export default ExportCompletions;
